import { barcodeSchema } from '../schemas/zod.schemas';
import { Barcode } from '../types/products.types';

export const STORE_PRODUCT_CSV_FIELDS = [
  'id',
  'name',
  'parent_id',
  'quantity_in_unit_package',
  'weight_kg',
  'unit',
  'unit_of_measurement',
  'price',
  'cost',
  'inventory',
  'min_selling_price',
  'max_selling_price',
  'is_sold_by_weight',
  'is_sold_by_range',
  'description',
  'image',
  'barcode',
  'barcodes',
] as const;

export type StoreProductCsvField = (typeof STORE_PRODUCT_CSV_FIELDS)[number];

const barcodeArraySchema = barcodeSchema.array();

export const normalizeBarcodeValue = (value: string | number): string =>
  String(value).trim();

export const isDefaultBarcode = (barcode: Barcode): boolean =>
  String(barcode.type).toLowerCase() === 'default';

export const serializeStoreProductBarcodes = (
  barcodes?: Barcode[] | null,
): string => JSON.stringify((barcodes ?? []).filter((bc) => !isDefaultBarcode(bc)));

export const parseStoreProductBarcodes = (value: unknown): Barcode[] => {
  let decoded: unknown;

  try {
    decoded = typeof value === 'string' ? JSON.parse(value) : value;
  } catch {
    throw new Error('barcodes must contain valid JSON');
  }

  const result = barcodeArraySchema.safeParse(decoded);
  if (!result.success) {
    throw new Error(
      'barcodes must be a JSON array of objects with value, type, and optional description',
    );
  }

  return result.data
    .filter((barcode) => !isDefaultBarcode(barcode))
    .map((barcode) => ({
      ...barcode,
      value: normalizeBarcodeValue(barcode.value),
    }));
};